
import { Injectable } from '@angular/core';
import { RestApiService } from '../../general/services/rest-api.service';
import { environment } from '../../../../environments/environment';
import { apiConst } from '../consts/apiConsts';


@Injectable({
  providedIn: 'root'
})
export class ActivityHitService {

  constructor(private restapi: RestApiService) { }
    getMenuexternal(requBdy:any){
        return this.restapi.postAPI(apiConst.activityHit,requBdy);
   }


}